"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATORS = exports.TYPES = void 0;
var EM_CASA_REQUEST_TOKEN = 'EM_CASA_REQUEST_TOKEN';
var EM_CASA_SUBMIT_TOKEN = 'EM_CASA_SUBMIT_TOKEN';
/**
 * Request to send an authentication token to the
 * given phone number
 * @param promiseDispatcher
 * @param phone
 * @returns {{phone: *, promiseDispatcher: *, type: string}}
 */

var requestToken = function requestToken(promiseDispatcher, phone) {
  return {
    type: EM_CASA_REQUEST_TOKEN,
    promiseDispatcher: promiseDispatcher,
    phone: phone
  };
};
/**
 * Submit and token to check if it's valid according with the backend
 * @param promiseDispatcher
 * @param phone
 * @param token
 * @param onSuccess
 * @param onError
 * @returns {{onError: *, phone: *, promiseDispatcher: *, type: string, token: *, onSuccess: *}}
 */


var submitToken = function submitToken(promiseDispatcher, phone, token, onSuccess, onError) {
  return {
    type: EM_CASA_SUBMIT_TOKEN,
    promiseDispatcher: promiseDispatcher,
    phone: phone,
    token: token,
    onSuccess: onSuccess,
    onError: onError
  };
};

var TYPES = {
  EM_CASA_SUBMIT_TOKEN: EM_CASA_SUBMIT_TOKEN,
  EM_CASA_REQUEST_TOKEN: EM_CASA_REQUEST_TOKEN
};
exports.TYPES = TYPES;
var CREATORS = {
  submitToken: submitToken,
  requestToken: requestToken
};
exports.CREATORS = CREATORS;